import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Auth, idToken } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private auth: Auth = inject(Auth);
  idToken$ = idToken(this.auth);
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.idToken$.pipe(
      take(1),
      mergeMap((idToken: string | null) => {
        if (idToken) {
          const scheme = 'Bearer';
          const authReq = req.clone({
            headers: req.headers.set('Authorization', `${scheme} ${idToken}`),
          });
          return next.handle(authReq);
        }
        return next.handle(req);
      }),
    );
  }
}

export const ApiInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ApiInterceptor,
  multi: true,
};
